<template>
  <div>
    <section class="pt-24 bg-white">
      <div class="px-12 mx-auto max-w-7xl">
        <div
          class="w-full mx-auto text-left md:w-11/12 xl:w-9/12 md:text-center"
        >
          <h1
            class="mb-8 text-4xl font-extrabold leading-none tracking-normal text-gray-900 md:text-6xl md:tracking-tight"
          >
            <span
              class="block w-full py-2 text-transparent bg-clip-text leading-12 bg-gradient-to-r from-green-400 to-purple-500 lg:inline"
              >Luxmi Chit Fund ($LCF)
            </span>
          </h1>
          <p class="py-12 mb-8 text-lg text-gray-600 md:text-xl lg:px-24">
            Luxmi Chit Fund (LCF) is a unique deflationary token inspired by
            famous memes from Movie Hera Pheri. Unlike other tokens, LCF has no
            tax on selling the coin, Instead LCF taxes on the transfer, and the
            taxes are random between 1-10% for each transaction. Additional tax
            of 3% goes into treasury which is used to grow LP & Marketing.
          </p>
          <div class="mb-4 space-x-0 md:space-x-2 md:mb-8">
            <a
              @click="showpresale"
              class="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg text-white bg-green-400 rounded-2xl sm:w-auto sm:mb-0"
            >
              Pre Sale
              <svg
                class="w-4 h-4 ml-1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </a>
            <a
              href="https://bscscan.com/token/0x4c602f5f89063cea006cf532cc38a58c2f73ed9e"
              class="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg bg-gray-100 rounded-2xl sm:w-auto sm:mb-0"
            >
              Smart Contract
              <svg
                class="w-4 h-4 ml-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
        <div v-if="!show">
          <div class="w-full mx-auto mt-20 text-center md:w-10/12">
            <div class="relative z-0 w-full mt-8">
              <div class="relative overflow-hidden shadow-2xl">
                <div
                  class="flex items-center flex-none px-4 bg-green-400 rounded-b-none h-11 rounded-xl"
                >
                  <div class="flex space-x-1.5">
                    <div
                      class="w-3 h-3 border-2 border-white rounded-full"
                    ></div>
                    <div
                      class="w-3 h-3 border-2 border-white rounded-full"
                    ></div>
                    <div
                      class="w-3 h-3 border-2 border-white rounded-full"
                    ></div>
                  </div>
                </div>
                <video width="100%" height="100%" autoplay>
                  <source
                    src="https://bafybeiawsqa3ikbrcfpbf6bwx7giji2hzjgtmno2ozjifgihzech3xedpq.ipfs.infura-ipfs.io"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-if="show">
      <div
        class="shadow-lg rounded-2xl bg-white m-auto p-2 w-1/3	border-8 border-gray-600	"
      >
        <img
          src="https://ipfs.io/ipfs/QmNpXaPdVRPQFyVJVHGtN35KE6tis8UWuhRZL5bfxCnnQd?filename=qr.png"
          alt="QR CODE"
          class="w-96 h-96 m-auto"
        />
        <div class="bg-gray-700 m-3 p-4 rounded-lg">
          <p class="text-white text-xl font-bold ">
            Send BNB To Address
          </p>
          <p class="text-gray-50 text-xs">
            Network : Binance Smart Chain
          </p>
          <div class="flex items-center justify-between ">
            <p class="text-white">
              0xa30a38ff54e1503a4c17ed5f8f64f18795e7d1c8
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      show: false,
    };
  },

  methods: {
    showpresale() {
      this.show = !this.show;
    },
  },
  mounted() {},
};
</script>
